import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPublications = store => store[NAME].publications;
export const getRoles = store => store[NAME].roles;
export const getPublicationTypes = store => store[NAME].publicationTypes;
export const getSocietyPeople = store => store[NAME].societyPeople;
export const getDateFormat = store => store[NAME].dateFormat;
